import { render, staticRenderFns } from "./Pagarme3DS.vue?vue&type=template&id=792a2152"
import script from "./Pagarme3DS.vue?vue&type=script&lang=js"
export * from "./Pagarme3DS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports